export default __webpack_public_path__ + "static/culture-rain-flip-a526f67bd2684ddadfd2f98bbff01bbb.svg";